import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as FeedbackActions from './feedback.actions';
import { catchError, map, mergeMap, of, tap } from 'rxjs';
import { Feedback } from '../../models/Feedback';
import { FeedbackService } from '../../services/FeedbackService';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class FeedbackEffects {
  loadFeedback$;
  submitFeedback$;

  constructor(private actions$: Actions, private feedbackService: FeedbackService, private snackBar: MatSnackBar) {
    this.loadFeedback$ = createEffect(() =>
      this.actions$.pipe(
        ofType(FeedbackActions.loadFeedback),
        mergeMap(() =>
          this.feedbackService.loadFeedback().pipe(
            map((feedback: Feedback[]) => FeedbackActions.loadFeedbackSuccess({ feedback })),
          )
        )
      )
    );

    this.submitFeedback$ = createEffect(() =>
      this.actions$.pipe(
        ofType(FeedbackActions.submitFeedback),
        mergeMap(({ feedbackText, rating, userName }) =>
          this.feedbackService.submitFeedback(feedbackText, rating, userName).pipe(
            map((savedFeedback: Feedback) => FeedbackActions.submitFeedbackSuccess({ feedback: savedFeedback })),
            tap(() => {
              this.snackBar.open('Feedback erfolgreich gesendet!', 'Schließen');
            }),
            catchError((error) => of(FeedbackActions.submitFeedbackFailure({ error })))
          )
        )
      )
    );
  }
}
